import styled from 'styled-components';
import { Popover as AntPopover } from 'antd';

export const Popover = styled(AntPopover)``;
